import { AppConfig } from "../shared/config/AppConfig.js";
import { Navbar } from "../shared/components/Navbar.js";
import { AuthService } from "../shared/services/AuthService.js";
import { ApiService } from "../shared/services/ApiService.js";
import { TemplateEngine } from "../shared/utils/TemplateEngine.js";
import dashboardTemplate from "./templates/dashboard.html?raw";
import notificationsTemplate from "./templates/notifications-modal.html?raw";
import Swal from "sweetalert2";
import { MaintenanceController } from "../maintenance/MaintenanceController.js";

export const DashboardController = {

	siteNamePublicidad: AppConfig.app.name,
	seccionPublicidad: "home",

	render: async () => {
		try {
			const siteNamePublicidad = AppConfig.app.name;
			const user = AuthService.getCurrentUser();
			localStorage.removeItem("ServiceToVehicle");
			const [vehicles, quotesLast, notifications, 
					adsHeader, 
					adsMedio, 
					adsPromos, 
					adsAutoPartes, 
					tiposMantResp, mantVehiculosResp] = await Promise.all([
				ApiService.post("apiapp/ObtenerVehiculos", null, user?.token),
				ApiService.post("apiapp/ObtenerPresupuestosNoVencidos10d", null, user?.token),
				ApiService.post("apiapp/Notificaciones", null, user?.token),
				ApiService.get(`apiapp/obtenerpublicidad?sector=1&seccion=${DashboardController.seccionPublicidad}&sitio=${DashboardController.siteNamePublicidad}&cantidad=1`),
				ApiService.get(`apiapp/obtenerpublicidad?sector=2&seccion=${DashboardController.seccionPublicidad}&sitio=${DashboardController.siteNamePublicidad}&cantidad=4`),
				ApiService.get(`apiapp/obtenerpublicidad?sector=3&seccion=${DashboardController.seccionPublicidad}&sitio=${DashboardController.siteNamePublicidad}&cantidad=2`),
				ApiService.get("apiapp/destacadasAutoPartes?cantidad=6"),
				ApiService.post("apiapp/TiposMantenimiento", null, user?.token),
				ApiService.post("apiapp/MantenimientoVehiculos", null, user?.token),
			]);

			const maintenanceTypes = tiposMantResp.message;
			const vehicleMaintenance = mantVehiculosResp.message;

			if (!Array.isArray(vehicles.vehiculos)) {
				throw new Error(vehicles.message || "No se pudo obtener la lista de vehículos");
			}

			// Obtener mantenimientos críticos y warnings usando MaintenanceController
			const allVehicles = vehicles.vehiculos.map((vehicle) => {
				const maintenances = MaintenanceController.getVisibleMaintenances(
					vehicle,
					maintenanceTypes,
					vehicleMaintenance,
				);

				const statusCounters = {
					critical: 0,
					warning: 0,
					ok: 0,
					noregistrado: 0,
				};

				maintenances.forEach((m) => {
					statusCounters[m.statusClass]++;
				});

				return {
					...vehicle,
					maintenances,
					statusCounters,
				};
			});

			const ResumeMantes = {
				criticalCount: 0,
				warningCount: 0,
				okCount: 0,
				noregistradoCount: 0,
				manteCriticos: [],
			};

			allVehicles.forEach((vehicle) => {
				const { statusCounters, maintenances } = vehicle;

				ResumeMantes.criticalCount += statusCounters.critical;
				ResumeMantes.warningCount += statusCounters.warning;
				ResumeMantes.okCount += statusCounters.ok;
				ResumeMantes.noregistradoCount += statusCounters.noregistrado;

				const criticalMaintenances = maintenances.filter((m) => m.statusClass === "critical");
				ResumeMantes.manteCriticos.push(...criticalMaintenances);
			});

			const hayCriticos = allVehicles.some(vehicle => vehicle.statusCounters.critical > 0);
			const hayWarnings = allVehicles.some(vehicle => vehicle.statusCounters.warning > 0);

			const adsHeaderItem = (adsHeader.ads || []).length > 0 ? adsHeader.ads[0].item : null;

			const data = {
				vehicleCount: `${vehicles.vehiculos.length}`,
				presupCount: `${quotesLast.message}`,
				notificationCount: `${notifications.message.filter((n) => !n.read).length}`,
				adsHeader: adsHeaderItem,
				adsMedio: adsMedio.ads,
				adsPromos: adsPromos.ads,
				adsAutoPartes: adsAutoPartes.ads,
				// Datos de mantenimiento
				maintenanceCount: ResumeMantes.criticalCount + ResumeMantes.warningCount,
				criticalCount: ResumeMantes.criticalCount,
				warningCount: ResumeMantes.warningCount,
				hasMaintenanceIssues: hayCriticos || hayWarnings,
				maintenanceCardClass: hayCriticos ? "border-danger" : "",
				maintenanceIconClass: hayCriticos ? "text-danger" : "text-success",
				maintenanceCountClass: hayCriticos ? "text-danger" : "text-success",
				maintenanceBtnClass: hayCriticos ? "danger" : "success",
				// Mantenimientos críticos para mostrar
				criticalMaintenances: ResumeMantes.manteCriticos.slice(0, 4), // Mostrar máximo 4
			};
			const content = TemplateEngine.render(dashboardTemplate, data);
			document.getElementById("app").innerHTML = await Navbar.render() + content;

			// Agregar animaciones escalonadas a las cards
			setTimeout(() => {
				const cards = document.querySelectorAll(".stats-card");
				cards.forEach((card, index) => {
					setTimeout(() => {
						card.style.animation = `fadeInUp 0.6s ease-out ${index * 0.1}s both`;
					}, index * 100);
				});
			}, 100);



			// Eventos
			//document.getElementById("btnViewNotifications").addEventListener("click", DashboardController.showNotifications);
			document.querySelectorAll(".btnhandleMaintenance").forEach((btn) => {
				btn.addEventListener("click", (e) => {
					const Dominio = parseInt(e.currentTarget.getAttribute("data-dominio"));
					DashboardController.handleMaintenance(Dominio);
				});
			});

			document.getElementById("btnViewNotifications").addEventListener("click", DashboardController.showNotifications);

		} catch (error) {
			console.error("Error loading dashboard data:", error);
			document.getElementById("app").innerHTML =
				await Navbar.render() +
				`<div class="container mt-4"><div class="alert alert-danger"><i class="fas fa-exclamation-triangle me-2"></i>${error.message || "Error al cargar el dashboard"}</div></div>`;
		}
	},

	showNotifications: async () => {
		try {
			const user = AuthService.getCurrentUser();
			const notifications = await ApiService.post("apiapp/Notificaciones", null, user?.token);
			const notifList = Array.isArray(notifications?.message) ? notifications.message : [];
			const unreadNotifications = notifList.filter((n) => !n.read);

			const modalContent = TemplateEngine.render(notificationsTemplate, { notifications: unreadNotifications, noNotifications: unreadNotifications.length === 0 });
			await Swal.fire({
				title: '<i class="fas fa-bell me-2"></i>Notificaciones',
				html: modalContent,
				width: 600,
				showCancelButton: false,
				confirmButtonText: "Cerrar",
			});


		} catch (error) {
			Swal.fire("Error", "No se pudieron cargar las notificaciones", "error");
		}
	},


	handleMaintenance: (Dominio) => {
		// Redirigir a la página de mantenimientos con el vehículo específico
		window.location.hash = "maintenance";

		// Después de un pequeño delay, podrías hacer scroll al vehículo específico
		setTimeout(() => {
			const vehicleCard = document.querySelector(`[data-vehicle-id="${Dominio}"]`);
			if (vehicleCard) {
				vehicleCard.scrollIntoView({ behavior: "smooth", block: "center" });
				vehicleCard.style.animation = "pulse 1s ease-in-out";
			}
		}, 500);
	},


};
